export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[640px] w-full items-center md:h-[680px]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Colorful%20collage%20of%20multiple%20cute%20manga%20characters%20and%20floating%20speech%20bubbles%20and%20open%20books%20on%20a%20warm%20gradient%20background%20of%20cream%20coral%20and%20gold%2C%20playful%20energetic%20anime%20illustration%20style%2C%20whimsical%20and%20inviting%2C%20high%20detail%20no%20text&width=1600&height=900&seq=hero-xiangxiang-01&orientation=landscape')",
        }}
        role="img"
        aria-label="香香漫画精美漫画插画背景"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-20 md:px-6">
        <div className="mx-auto flex max-w-3xl w-full flex-col items-center text-center">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-1.5 text-sm text-white backdrop-blur-sm">
            <i className="ri-fire-line" aria-hidden="true"></i>
            精选优质漫画 · 高分排行一网打尽
          </span>

          <h1 className="font-heading text-4xl leading-tight text-white md:text-6xl">
            好看优质漫画
            <br className="md:hidden" />
            <span className="text-accent-400"> 点开即看</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
            香香漫画为你精选高分、优质、好看的漫画作品，热门分类、编辑推荐、实时排行统统都有。
            无论是热血冒险、悬疑烧脑还是温馨治愈，想看好漫画，从这里开始。
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <a
              href="#featured"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-base text-white transition-all hover:bg-primary-600 sm:w-auto"
            >
              看看编辑精选
              <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
            </a>
            <a
              href="#ranking"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-white/30 bg-white/10 px-8 py-3.5 text-base text-white backdrop-blur-sm transition-colors hover:bg-white/20 sm:w-auto"
            >
              查看高分排行
            </a>
          </div>

          <dl className="mt-12 grid w-full max-w-xl grid-cols-3 gap-4">
            {[
              { num: "1200+", label: "精选优质作品" },
              { num: "38万+", label: "漫画爱好者" },
              { num: "9.6分", label: "高分口碑之作" },
            ].map((item) => (
              <div
                key={item.label}
                className="rounded-2xl border border-white/15 bg-white/10 px-3 py-4 text-center backdrop-blur-sm"
              >
                <dt className="sr-only">{item.label}</dt>
                <dd className="font-heading text-2xl text-white md:text-3xl">{item.num}</dd>
                <dd className="mt-1 text-xs text-white/75">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}